import type { CSSProperties } from 'react';
import type { SxProps, Theme } from '@mui/material/styles';

export const iframeStyle: CSSProperties = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  width: '100%',
  height: '100%',
  border: 0
};

const comparePdfsModalStyles = {
  panel: {
    flex: 1,
    border: 1,
    borderColor: 'divider',
    borderRadius: 1,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0
  },
  panelHeader: {
    px: 1.5,
    py: 1,
    bgcolor: 'grey.100',
    borderBottom: 1,
    borderColor: 'divider',
    flexShrink: 0
  },
  panelContent: {
    flex: 1,
    position: 'relative' as const,
    minHeight: 0
  },
  loadingSpinnerWrapper: {
    position: 'absolute' as const,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 1
  },
  errorWrapper: {
    position: 'absolute' as const,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
    px: 2,
    zIndex: 1
  },
  emptyStateWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%'
  },
  dialogPaper: {
    width: '95vw',
    maxWidth: '95vw',
    height: '95vh',
    maxHeight: '95vh',
    m: 1
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '95vh',
    overflow: 'hidden'
  },
  header: {
    p: 2,
    borderBottom: 1,
    borderColor: 'divider',
    flexShrink: 0
  },
  title: {
    mb: 1.5
  },
  tabs: {
    minHeight: 40,
    '& .MuiTab-root': { minHeight: 40 }
  },
  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    p: 2
  },
  centerContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1
  },
  panelsContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0
  },
  panelsStack: {
    flex: 1,
    minHeight: 0
  },
  footer: {
    p: 2,
    display: 'flex',
    justifyContent: 'flex-end',
    borderTop: 1,
    borderColor: 'divider',
    flexShrink: 0
  }
} as const satisfies Record<string, SxProps<Theme>>;

export default comparePdfsModalStyles;
